import { createAction } from "@reduxjs/toolkit";
import axios from "axios";
import { FETCH_INTEGRATION_OPPORTUNITIES_REQUEST, FETCHING_INTEGRATION_OPPORTUNITIES_FAILED, FETCHING_INTEGRATION_OPPORTUNITIES_SUCCEEDED } from "./actionTypes";
import { FetchIntegrationOpportunities, FetchIntegrationOpportunitiesFailed } from "src/types/opportunities";
import { PaginatedRecords } from "src/types/common";
import { Opportunity } from "src/types/conversations";
import { call, put, takeEvery } from "redux-saga/effects";

const apiUrl = process.env.REACT_APP_API_URL;
const OPPORTUNITY_BASE_URL = `${apiUrl}/api/2.0/opportunities`;

export const fetchOpportunities = createAction<FetchIntegrationOpportunities>(FETCH_INTEGRATION_OPPORTUNITIES_REQUEST)
const fetchingOpportunitiesSucceeded = createAction<PaginatedRecords<Opportunity>>(FETCHING_INTEGRATION_OPPORTUNITIES_SUCCEEDED)
const fetchingOpportunitiesFailed = createAction<FetchIntegrationOpportunitiesFailed>(FETCHING_INTEGRATION_OPPORTUNITIES_FAILED)

export const fetchOpportunitySaga = function* (action: ReturnType<typeof fetchOpportunities>) {
  const { query, page, limit = 25 } = action.payload;
  const fetchOpportunitiesApi = async () => {
    return axios({
      method: 'GET',
      url: OPPORTUNITY_BASE_URL,
      params: {
        query,
        page,
        limit
      }
    }).then((response) => response.data);
  }
  try {
    const response = yield call(fetchOpportunitiesApi);
    yield put(fetchingOpportunitiesSucceeded(response || {
      currentPage: 0,
      records: [],
      totalPages: 0,
      recordsPerPage: 0,
      totalRecordsCount: 0,
    }));
  } catch (error) {
    yield put(fetchingOpportunitiesFailed({ error }));
  }
}

export default function* opportunitiesSaga() {
    yield takeEvery(FETCH_INTEGRATION_OPPORTUNITIES_REQUEST, fetchOpportunitySaga);
}